/**
 * directive for typeahead publications list
 * @author Umer Hassan
 */

import template from './searchPubs.html';
import controller from './SearchPubsController';

function searchPubs() {
  return {
    template,
    restrict: 'E',
    scope: {
      update: '&', // method call for parent controller to provide name, id etc
      pitches: '=', // story pitches
      disabled: '=', // if we want to disable the input tag
      clearOnSelection: '=', // whether the input should be cleared after selection
      isRequired: '=', // whether the input is required or not (for form submission)
      excluded: '=',
      publicationName: '=?',
      site: '='
    },
    controller: 'SearchPubsController'
  };
}

export default function (ngModule) {
  ngModule.directive('searchPubs', [
    searchPubs
  ]);
  controller(ngModule);
}
